module.exports = __webpack_public_path__ + "static/img/logo_4.574357d6.png";